import React, { useState } from "react";
import { Modal, Button } from "antd";

const UpdateContactModal = ({
  title,
  description,
  ctaLabel,
  closeLabel,
  ctaLink,
  billingLabel,
  shippingLabel,
  billingAddress,
  shippingAddress,
  emailLabel,
  phoneLabel,
  email,
  phone,
}) => {
  const [visible, setVisible] = useState(true);

  const handleClose = (e) => {
    e.preventDefault();
    setVisible(false);
  };

  return (
    <Modal
      className="update-contact-modal"
      title={title}
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <div className="update-contact-modal__body">
        <p>{description}</p>

        <div className="update-contact-modal__contact-info">
          <p>
            <strong>{emailLabel}:</strong> {email || ""}
          </p>
          <p>
            <strong>{phoneLabel}:</strong> {phone || ""}
          </p>
        </div>

        <div className="update-contact-modal__addresses">
          <div className="update-contact-modal__address">
            <h4>{billingLabel}</h4>
            {/** Because get_formatted_address may return HTML (like <br>),
                 we can dangerouslySetInnerHTML or strip tags. Here we show the raw HTML. */}
            <div
              className="update-contact-modal__address-content"
              dangerouslySetInnerHTML={{ __html: billingAddress }}
            />
          </div>

          <div className="update-contact-modal__address">
            <h4>{shippingLabel}</h4>
            <div
              className="update-contact-modal__address-content"
              dangerouslySetInnerHTML={{ __html: shippingAddress }}
            />
          </div>
        </div>
      </div>

      <div className="update-contact-modal__footer">
        <a className="button green" href={ctaLink}>
          {ctaLabel}
        </a>
        <div className="button gray" onClick={(e) => handleClose(e)}>
          {closeLabel}
        </div>
      </div>
    </Modal>
  );
};

export default UpdateContactModal;
